import { useState, useRef, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Body } from 'ggx-componentlibrary/design/typography/typography.styles'
import { StyledError } from 'ggx-componentlibrary/components/text-field/text-field.component.styles'
import {
  Container,
  StyledTextArea,
  Footer,
  TemplateContainer,
  TemplateList,
  TemplateItem,
  StyledIconPlus,
  StyledIconVerticalArrow,
  StyleCounter,
} from './text-area.component.style'

const TextArea = ({
  className,
  placeholder,
  minRows,
  meta,
  input,
  maxLength,
  templates,
}) => {
  const inputRef = useRef()
  const inputStyleRef = useRef({})
  const adjustTextareaRows = useCallback(
    textareaElem => {
      textareaElem.rows = minRows
      textareaElem.rows = Math.max(
        minRows,
        (textareaElem.scrollHeight -
          inputStyleRef.current.paddingTop -
          inputStyleRef.current.paddingBottom) /
          inputStyleRef.current.lineHeight
      )
    },
    [input]
  )
  useEffect(() => {
    inputRef.current.value = input.value
    inputRef.current.rows = minRows
    const style = window.getComputedStyle(inputRef.current)
    inputStyleRef.current = {
      paddingTop: Number(style['padding-top'].replace(/\D/g, '')),
      paddingBottom: Number(style['padding-bottom'].replace(/\D/g, '')),
      lineHeight: Number(style['line-height'].replace(/\D/g, '')),
    }
    if (input.value) {
      adjustTextareaRows(inputRef.current)
    }
  }, [input.value])

  const error = meta.dirty && meta.error

  const listRef = useRef()
  const [hasHiddenItem, setHasHiddenItem] = useState(false)
  const [isExpand, setIsExpand] = useState(false)
  useEffect(() => {
    if (listRef.current) {
      const { scrollHeight, clientHeight } = listRef.current
      if (Math.round(scrollHeight / clientHeight) > 1) {
        setHasHiddenItem(true)
      }
    }
  }, [])
  return (
    <div className={className}>
      <Container error={error}>
        <StyledTextArea
          data-error-field={!!error}
          ref={inputRef}
          placeholder={placeholder}
          name={input.name}
          error={error}
          value={input.value}
          rows={minRows}
          onChange={event => {
            input.onChange(event.target.value)
            adjustTextareaRows(event.target)
          }}
        />
        <Footer>
          <TemplateContainer>
            <TemplateList ref={listRef} isExpand={isExpand}>
              {templates?.map(template => (
                <TemplateItem
                  onClick={() => {
                    input.onChange(
                      input.value +
                        (!input.value
                          ? ''
                          : input.value[input.value.length - 1] === '\n'
                          ? '\n'
                          : '\n\n') +
                        template[1]
                    )
                    setTimeout(() => {
                      inputRef.current.focus()
                      adjustTextareaRows(inputRef.current)
                    })
                  }}
                >
                  <StyledIconPlus />
                  <Body typographyStyles="mb-none c-blue_medium">
                    {template[0]}
                  </Body>
                </TemplateItem>
              ))}
            </TemplateList>
            {hasHiddenItem ? (
              <StyledIconVerticalArrow
                isExpand={isExpand}
                onClick={() => setIsExpand(v => !v)}
              />
            ) : null}
          </TemplateContainer>
          {maxLength && (
            <StyleCounter typographyStyles={error ? 'c-red_medium' : ''}>
              {input.value.length}/{maxLength}
            </StyleCounter>
          )}
        </Footer>
      </Container>
      {typeof meta.error === 'string' && meta.error.length > 0 && (
        <StyledError>{meta.error}</StyledError>
      )}
    </div>
  )
}

TextArea.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  minRows: PropTypes.number,
  meta: PropTypes.shape({
    dirty: PropTypes.string,
    error: PropTypes.string,
  }),
  input: PropTypes.shape({
    value: PropTypes.any,
    onChange: PropTypes.func,
  }),
  maxLength: PropTypes.number,
  templates: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
}

TextArea.defaultProps = {
  meta: {},
  input: {},
  minRows: 1,
}

export { TextArea }
